import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { BrandsDashboardQueryKeys } from "modules/BrandsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { BrandGroup, BrandGroupID } from "models";

export type BrandGroupFormPayload = Pick<
  BrandGroup,
  | "id"
  | "name"
  | "country"
  | "color"
  | "is_active"
  | "button_label"
  | "tablet_service_button_url"
  | "servicebox_wo"
  | "servicebox_vin"
  | "servicebox_wo_2_name"
  | "servicebox_wo_2"
  | "logo"
>;

export const useCreateBrandGroupMutation = () =>
  useTypedMutation<BrandGroupFormPayload, BrandGroupID>({
    mutationFn: async payload => (await ApiInstance.post("/brands/groups/create", payload, ENV.carBaseURL)).data.brand_group_id,
    onSuccess: (payload, id) => {
      const previousBrandGroups = typedQueryClient.getQueryData(BrandsDashboardQueryKeys.brandGroups) ?? [];
      const groupIdx = previousBrandGroups.findIndex(group => group.id === id);
      if (groupIdx !== -1) return;

      typedQueryClient.setQueryData(BrandsDashboardQueryKeys.brandGroups, [...previousBrandGroups, { ...payload, id, brands: [] }]);
    }
  });
